class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      
      
      this.onCartUpdate();
    });
    
    // window.checkGiftEligibiltySSE();
    


  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch('/cart?section_id=main-cart-items')
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = 
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = 
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};




window.checkBundleEligibilty = function () {
  

        var CAPS_ID = [6963267436736, 6963268288704];
    var JACKETS_ID = [7466167599296, 7466167828672, 7466281894080];
    var BAGS_ID = [7140732108992, 7140731846848, 7140731945152, 7140732240064, 7140732371136];
    window.caps_found = false;
    window.bags_found = false;
    window.jackets_found = false;
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((ele) => {
        if(CAPS_ID.includes(ele.product_id)){
          console.log("caps found");
          caps_found = true;
        }
        if(JACKETS_ID.includes(ele.product_id)){
          console.log("JACKETS_ID found");
          jackets_found = true;
        }
        if(BAGS_ID.includes(ele.product_id)){
          console.log("BAGS_ID found");
          bags_found = true;
        }
      })
      if(caps_found || jackets_found || bags_found){
          if(!(caps_found && jackets_found && bags_found)){
            console.log("Show popup")
            Fancybox.show([{ src: "#dialog-content-bundle", type: "inline" }]);
          }
      }
    if(window.caps_found){
      var element = document.getElementById("cap-bg");
      element.innerHTML = "Already In The Cart"
      element.classList.add("cap-bg");
    }
    else {
      document.getElementById("cap-bg").innerHTML = ""
    }
    if(window.bags_found){
        var element = document.getElementById("bag-bg");
        element.innerHTML = "Already In The Cart"
        element.classList.add("bag-bg");
    }
    else {
      document.getElementById("bag-bg").innerHTML = ""
    }
    if(window.jackets_found){
        var element = document.getElementById("jacket-bg");
        element.innerHTML = "Already In The Cart"
        element.classList.add("jacket-bg");
    }
    else {
      document.getElementById("jacket-bg").innerHTML = ""
    }
    });

}


window.checkGiftEligibilty = function() {
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

  console.log(cartTotal)

  if(cartTotal > 130) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var foundFreeProduct = false;
      var freeProductIDs = [ 7488098205888, 7488098173120, 7488098271424, 7488098533568, 7488098697408, 7488098435264 ]
      data.items.forEach((ele) => {
        if(freeProductIDs.includes(ele.product_id))
          foundFreeProduct = true;
        console.log("foundFreeProduct", foundFreeProduct)
      })
      console.log("foundFreeProduct", foundFreeProduct)
       // !foundFreeProduct && window
       //  .fetch('/cart/add.js', {
       //    method: 'POST',
       //    headers: {
       //      Accept: 'application/json',
       //      'Content-Type': 'application/json',
       //    },
       //    body: JSON.stringify({
       //      id: 43607705780416,
       //      quantity: 1
       //    })
       //  })
       //  .then(response => response.json())
       //  .then(data => {
       //    window.location = "https://www.graceandlace.com/";
       //  })
       //  .catch( err => console.log(err))
      !foundFreeProduct && Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
      
    })
  }
}




window.checkGiftEligibiltyPFT = function() {
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

  console.log("cartTotal", cartTotal)

  if(cartTotal > 75) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {

      var freeProductIDs = [ 7497453732032 ]
      var totalFreeItemInCart = 0
      var totalGiftCard = 0
      var totalFreeItemValueInCart = 0
      
      data.items.forEach((ele) => {
        if(freeProductIDs.includes(ele.product_id)) {
          totalFreeItemInCart = totalFreeItemInCart + ele.quantity
        }
        if(ele.gift_card) {
          totalGiftCard = totalGiftCard + (ele.line_price/100)
        }
        if(freeProductIDs.includes(ele.product_id)) {
          totalFreeItemValueInCart = totalFreeItemValueInCart + + (ele.line_price/100)
        }
      })
      console.log("totalFreeItemValueInCart", totalFreeItemValueInCart)
      console.log("totalGiftCard", totalGiftCard)
      cartTotal = cartTotal - totalGiftCard - totalFreeItemValueInCart;
      console.log("cartTotal", cartTotal)
      
      var totalFreeItemsNeedsToAdd = 0
      if(cartTotal > 125) {
        totalFreeItemsNeedsToAdd = 2 - totalFreeItemInCart;
      }
      else if ( cartTotal > 75 ) {
        totalFreeItemsNeedsToAdd = 1 - totalFreeItemInCart;
      }
      
      console.log("totalFreeItemsNeedsToAdd", totalFreeItemsNeedsToAdd)
      
      totalFreeItemsNeedsToAdd > 0 && window
        .fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: 43719510098112,
            quantity: totalFreeItemsNeedsToAdd
          })
        })
        .then(response => response.json())
        .then(data => {
          // window.location = "https://www.graceandlace.com/";
          window.location.reload()
        })
        .catch( err => console.log(err))


      
    })
  }
}




window.checkGiftEligibiltyBOGO = function () {

      var getItemsSlug = ["modal-sleep-shorts", "modal-sleep-tee", "modal-sleep-tank"]
      
      var checkURL = window.location.pathname
      for (item of getItemsSlug) {
        if (checkURL.includes(item)) {
          return;
        }
      }

  
  
    var GetProductsIDs = [6925085606080, 6925051527360, 6898864455872]
    var BuyProductsIDs = [7510974726336, 7511620223168, 7511714824384]
    var totalGetProductsInCart = 0
    var totalBuyProductsInCart = 0
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((ele) => {
        if(GetProductsIDs.includes(ele.product_id)){
          console.log("GEt Products found");
          totalGetProductsInCart += ele.quantity
        }
        if(BuyProductsIDs.includes(ele.product_id)){
          console.log("Buy Products found");
          totalBuyProductsInCart += ele.quantity
        }
      })
      var reminingProductsGift = totalBuyProductsInCart - (totalGetProductsInCart * 2);


      if (reminingProductsGift >= 2) {
            console.log("Show popup", "reminingProductsGift", reminingProductsGift )
            Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
      }
    });

}

window.checkGiftEligibiltyBgiftpalooza = function () {

      var getItemsSlug = ["leggings"]
      
      var checkURL = window.location.pathname
      for (item of getItemsSlug) {
        if (checkURL.includes(item)) {
          return;
        }
      }

  
  
    var GetProductsIDs = [7449755156672, 7449754075328, 7334018613440, 7334000656576, 7332324802752, 7319689724096, 7140739875008, 7140739678400, 7047273939136]
    var BuyProductsIDs = [7553201504448, 7553195376832, 7553186234560, 7523242049728, 7523240870080, 7014471205056]
    var totalGetProductsInCart = 0
    var totalBuyProductsInCart = 0
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((ele) => {
        if(GetProductsIDs.includes(ele.product_id)){
          console.log("GEt Products found");
          totalGetProductsInCart += ele.quantity
        }
        if(BuyProductsIDs.includes(ele.product_id)){
          console.log("Buy Products found");
          totalBuyProductsInCart += ele.quantity
        }
      })
      
      var reminingProductsGift = totalBuyProductsInCart - totalGetProductsInCart;

      console.log("totalBuyProductsInCart", totalBuyProductsInCart)
      console.log("totalGetProductsInCart", totalGetProductsInCart)
      console.log("reminingProductsGift", reminingProductsGift)

      if (reminingProductsGift >= 1) {
            console.log("Show popup", "reminingProductsGift", reminingProductsGift )
            Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
      }
    });

}


window.checkGiftTierpopup = function() {


      //   var getItemsSlug = ["cyber-monday-gifts"]
      
      // var checkURL = window.location.pathname
      // for (item of getItemsSlug) {
      //   if (checkURL.includes(item)) {
      //     return;
      //   }
      // }

  console.log("hello")
  
    var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
    var cartTotalUSD = cartTotalElement.replace("USD", "");
    var cartTotal = parseFloat(cartTotalUSD);

    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          
            var excludeProductIDs = [ 7498292756672, 6113082966208, 786360729717, 8116982218944  ]
            var totalexcludeItemValueInCart = 0



          

          
       
          
              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) == false ) {
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100);
                }
                
              })
          
            cartTotal = totalexcludeItemValueInCart;
            console.log("cartTotal", cartTotal)

         


          if (cartTotal >= 150    ) {
                
                document.getElementById("shopNowLink").href = "https://www.graceandlace.com/collections/after-christmas-sale-free-gift-tier-3";

               var a = localStorage.getItem('AFS150')
               a != "true" && Fancybox.show([{
                  src: "#dialog-content",
                  type: "inline"
                }]);
               localStorage.setItem('AFS150', 'true');
           
            }


            


                    
            else if (cartTotal >= 100 ) {
                
                document.getElementById("shopNowLink").href = "https://www.graceandlace.com/collections/after-christmas-sale-free-gift-tier-2";

               var a = localStorage.getItem('AFS100')
               a != "true" && Fancybox.show([{
                  src: "#dialog-content",
                  type: "inline"
                }]);
               localStorage.setItem('AFS100', 'true');
         
            }
          

            else if (cartTotal >= 75 ) {
                
                document.getElementById("shopNowLink").href = "https://www.graceandlace.com/collections/after-christmas-sale-free-gift-tier-1";


               var a = localStorage.getItem('AFS75')
               a != "true" && Fancybox.show([{
                  src: "#dialog-content",
                  type: "inline"
                }]);
               localStorage.setItem('AFS75', 'true');
            }

           
        });
}


window.checkGiftEligibiltyBOGOBambu = function () {

      var getItemsSlug = ["glacier-grey-bambu-decorative-pillowcase", "satin-and-bambu-pillowcase-in-white", "satin-and-bambu-pillowcase-in-white-standard-size-1", '/collections/cozy-days-sale-free-gift', '/collections/home-goods/pillowcase']
      console.log(window.location.pathname);
      var checkURL = window.location.pathname
      for (item of getItemsSlug) {
        if (checkURL.includes(item)) {
          return;
        }
      }

    var GetProductsIDs = [7320680628416, 7414780723392, 6975746179264]
    var BuyProductsIDs = [7553201504448, 7553186234560, 7553195376832]
    var totalGetProductsInCart = 0
    var totalBuyProductsInCart = 0
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((ele) => {
        if(GetProductsIDs.includes(ele.product_id)){
          console.log("GEt Products found");
          totalGetProductsInCart += ele.quantity
        }
        if(BuyProductsIDs.includes(ele.product_id)){
          console.log("Buy Products found");
          totalBuyProductsInCart += ele.quantity

            if (BuyProductsIDs.includes(ele.product_id)) {
            console.log("Show popup for product ID: ", ele.product_id);
            Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
          }
          
        }
      })
      
      var reminingProductsGift = totalBuyProductsInCart - (totalGetProductsInCart * 2);

      if (remainingProductsGift >= 1 && totalGetProductsInCart < 2) {
        console.log("Show popup", "remainingProductsGift", remainingProductsGift);
        Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
      }
    });

}


window.checkGiftEligibiltySweetheartDeals = function() {
  
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

  console.log("cartTotal: " + cartTotal)
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          
            // product id of Makeup Bag and gift card
            var excludeProductIDs = [ 7689661972672, 7689665577152, 7498292756672, 6113082966208, 786360729717]
            var totalexcludeItemValueInCart = 0

            var GWPBags = [ 7689661972672, 7689665577152]
            var GWPBagsExists = false;

              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) ) {
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100)
                }

                //if cart already contains Bags then just return
                if(GWPBags.includes(ele.product_id) ) {
                  console.log("GWP Exists")
                  GWPBagsExists = true;
                  return;
                }
              })
          
            cartTotal = cartTotal  - totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal)

          if (GWPBagsExists == false && cartTotal >= 125) {
            
                  Fancybox.show([{
                    src: "#dialog-content",
                    type: "inline"
                }]);
           
            } 
        });

}

window.checkAlmostEverythingSale = function() {
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {




      
            var excludeProductIDs = [7606364668096, 7498292756672, 6113082966208, 786360729717 ]
            var totalexcludeItemValueInCart = 0;

              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) ) {
                   console.log("Excluded Product Found");
           
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100);
                  
                 
                }
              })
           console.log("total excluded item value: ",totalexcludeItemValueInCart);
            cartTotal = cartTotal  - totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal);

       if (cartTotal >= 150) {
    
          var foundFreeProduct = false;
          var freeProductIDs = [7606364668096]
          data.items.forEach((ele) => {
            
            if(freeProductIDs.includes(ele.product_id))
              foundFreeProduct = true;
            
          })
          // console.log("foundFreeProduct", foundFreeProduct)
          // console.log("Free Product Should be added to cart ");
    
            !foundFreeProduct && window
            .fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: 44113724309696,
                quantity: 1
              })
            })
             .then(response => response.json())
            .then(data => {
              window.location.reload()
            })
            .catch( err => console.log(err))
      }
    })
}


window.mothersDayFreeGift = function() {


        var getItemsSlug = ["products/flowy-kimono-in-"]
      console.log(window.location.pathname);
      var checkURL = window.location.pathname
      for (item of getItemsSlug) {
        if (checkURL.includes(item)) {
          return;
        }
      }
  
  
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

  console.log("cartTotal: " + cartTotal)
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          
            // product id of Makeup Bag and gift card
            var excludeProductIDs = [ 7761215848640, 7761218109632, 7761218470080, 7761216504000, 7761213915328, 7498292756672, 6113082966208, 786360729717]
            var totalexcludeItemValueInCart = 0

            var GWPBags = [  7761215848640, 7761218109632, 7761218470080, 7761216504000, 7761213915328]
            var GWPBagsExists = false;

              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) ) {
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100)
                }

                //if cart already contains Bags then just return
                if(GWPBags.includes(ele.product_id) ) {
                  console.log("GWP Exists")
                  GWPBagsExists = true;
                  return;
                }
              })
          
            cartTotal = cartTotal  - totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal)

          if (GWPBagsExists == false && cartTotal >= 150) {
            
                  Fancybox.show([{
                    src: "#dialog-content",
                    type: "inline"
                }]);
           
            } 
        });

}




window.customPopupBasedOnCartValue = function() {
  
  
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

  console.log("cartTotal: " + cartTotal)
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          
            // product id of Makeup Bag and gift card
            var excludeProductIDs = [ 7498292756672, 6113082966208, 786360729717]
            var totalexcludeItemValueInCart = 0


              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) ) {
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100)
                }
                
              })
          
            cartTotal = cartTotal  - totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal)

          var cart100Crossed = getCookieMy('TYSPopup100');
          var cart125Crossed = getCookieMy('TYSPopup125');
          console.log("cart100Crossed", cart100Crossed);
          console.log("cart125Crossed", cart125Crossed);
          
          if (cart100Crossed == null  && cartTotal >= 100) {
            
              setCookieMy('TYSPopup100', 'true', 2)
              Fancybox.show([{
              src: "#dialog-content-1",
              type: "inline"
              }]); 
            
          }
        });

}


function setCookieMy(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookieMy(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookieMy(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}





window.funInTheSale = function() {
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {

      
            var excludeProductIDs = [7974759858368, 7974756384960, 7974756253888, 7498292756672, 6113082966208, 786360729717 ]
            var totalexcludeItemValueInCart = 0;

            var foundFreeProduct = false;
            var freeProductIDs = [7974759858368, 7974756384960, 7974756253888]

            data.items.forEach((ele) => {
              
            if(excludeProductIDs.includes(ele.product_id) ) {
              console.log("Excluded Product Found");
              totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100);
            }
            
            if(freeProductIDs.includes(ele.product_id)) {
                foundFreeProduct = true;
            }            
            })
      
            console.log("total excluded item value: ",totalexcludeItemValueInCart);
            cartTotal = cartTotal  - totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal);
            
            
            
            
            if (cartTotal >= 130 && foundFreeProduct == false) {
            
              Fancybox.show([{
              src: "#dialog-content",
              type: "inline"
              }]);
            
            }

         
      })
}

// e gift card 786360729717
//  PP 7498292756672
// C gift card 6113082966208
// new PP 8116982218944


window.checkGiftEligibiltySSE = function() {
  
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

  console.log("cartTotal: " + cartTotal)
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          
            // product id of Makeup Bag and gift card
            var excludeProductIDs = [ 8116982218944, 7498292756672, 6113082966208, 786360729717, 757680996469 ]
            var totalexcludeItemValueInCart = 0

            var GWPBags = [ 757680996469 ]
            var GWPBagsExists = false;

              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) ) {
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100)
                }

                //if cart already contains Bags then just return
                if(GWPBags.includes(ele.product_id) ) {
                  console.log("GWP Exists")
                  GWPBagsExists = true;
                  return;
                }
              })
          
            cartTotal = cartTotal  - totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal)

          if (GWPBagsExists == false && cartTotal >= 125) {
            
            window
              .fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: 45846628991168,
                  quantity: 1
                })
              })
              .then(response => response.json())
              .then(data => {
                 window.location.reload()
              })
              .catch( err => console.log(err))
           
          } 
        });

}



window.CheckCMBSale = function() {
  var cartTotalElement = document.getElementsByClassName("totals__subtotal-value")[0].textContent.replace("$", '');
  var cartTotalUSD = cartTotalElement.replace("USD","");
  var cartTotal = parseFloat(cartTotalUSD);

    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {


      
            var excludeProductIDs = [ 7498292756672, 6113082966208, 786360729717, 8116982218944 ]
            var totalexcludeItemValueInCart = 0;

              data.items.forEach((ele) => {
                if(excludeProductIDs.includes(ele.product_id) == false ) {
                   console.log("Excluded Product Found");
           
                  totalexcludeItemValueInCart = totalexcludeItemValueInCart + (ele.line_price/100);
                  
                 
                }
              })
           // console.log("total incli item value: ",totalexcludeItemValueInCart);
            cartTotal =  totalexcludeItemValueInCart;
            console.log("cartTotal Final: ", cartTotal);

       if (cartTotal >= 115) {

         var a = localStorage.getItem('CYB115')
         a != "true" && Fancybox.show([{
            src: "#dialog-content",
            type: "inline"
          }]);
         localStorage.setItem('CYB115', 'true');
         // localStorage.setItem('CYB75', 'true');
         localStorage.setItem('CYB35', 'true');

          
      }
      // else  if (cartTotal >= 75) {

      //    var a = localStorage.getItem('CYB75')
      //    a != "true" && Fancybox.show([{
      //       src: "#dialog-content",
      //       type: "inline"
      //     }]);
      //    localStorage.setItem('CYB75', 'true');
      //   localStorage.setItem('CYB35', 'true');

          
      // }
      else  if (cartTotal >= 35) {

         var a = localStorage.getItem('CYB35')
         a != "true" && Fancybox.show([{
            src: "#dialog-content",
            type: "inline"
          }]);
        localStorage.setItem('CYB35', 'true');

          
      }
    })
}


window.checkValentineGiftEligibilty = function () {
  var new_items = [8157794599104, 8157290594496, 8157799383232, 8157143564480, 8157137207488, 8157220274368, 8157234102464, 8157306945728, 8157297541312, 8157726048448, 8157733880000, 8157778804928, 8157786308800, 8157789257920, 8157791813824]; 
  var new_found = false;

  var freeGiftItems = [8153330155712];
  var freeGiftItems_found = false;


    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((ele) => {
        if(new_items.includes(ele.product_id)){
          console.log("new item found");
          new_found = true;
        }
        if(freeGiftItems.includes(ele.product_id)){
          console.log("new item found");
          freeGiftItems_found = true;
        }
      })

      console.log("hhii", freeGiftItems_found, new_found);

      if (new_found == true && freeGiftItems_found == false) {
        window.fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: 45997646020800,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          // window.location = "https://www.graceandlace.com/";
          // window.location.reload()
        })
        .catch( err => console.log(err))
      }
      
    })

}




